// activeFolderStorage.js
// "Aktif klasör" seçimini localStorage'da kalıcı tutar + cross-component senkron için
// custom event yayınlar. SavedDistributions ve useDistributionFolders ayrı state
// instance'larıdır; bu modül onları aynı kaynak üzerinden eşit tutar.

const ACTIVE_FOLDER_KEY = 'activeFolderId';
export const ACTIVE_FOLDER_EVENT = 'distribution-active-folder-updated';

export const readActiveFolderId = () => {
  const raw = localStorage.getItem(ACTIVE_FOLDER_KEY);
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

export const persistActiveFolderId = (folderId) => {
  if (folderId == null) {
    localStorage.removeItem(ACTIVE_FOLDER_KEY);
  } else {
    localStorage.setItem(ACTIVE_FOLDER_KEY, String(folderId));
  }
  window.dispatchEvent(new Event(ACTIVE_FOLDER_EVENT));
};

export const subscribeActiveFolderChanges = (callback) => {
  window.addEventListener(ACTIVE_FOLDER_EVENT, callback);
  return () => window.removeEventListener(ACTIVE_FOLDER_EVENT, callback);
};

/**
 * `foldersList` içinden geçerli activeFolder id'yi seç: localStorage'daki kayıt
 * hâlâ listede mevcutsa onu, değilse son klasörü döner. Liste boşsa null.
 */
export const pickInitialActiveFolderId = (foldersList) => {
  if (!Array.isArray(foldersList) || foldersList.length === 0) return null;
  const saved = readActiveFolderId();
  if (saved != null && foldersList.some((f) => f.id === saved)) return saved;
  return foldersList[foldersList.length - 1]?.id ?? null;
};
